import searchIcon from "assets/svg/searchIcon.svg";

export const SearchInput = ({
  handleInputChange,
  fullWidth,
  transparentType,
  longer,
}: {
  handleInputChange: (val: string) => void;
  fullWidth?: boolean;
  transparentType?: boolean;
  longer?: boolean;
}) => {
  return (
    <div className="group relative">
      <img
        className={`absolute ${longer ? "top-3" : "top-2"} left-4`}
        src={searchIcon}
        alt={""}
      />
      <input
        type={"text"}
        onChange={(e) => handleInputChange(e.target.value)}
        className={` ${
          transparentType
            ? "bg-white border border-[#D0D5DD]"
            : "bg-white border border-[#D0D5DD]"
        } px-4 pl-10 hover:bg-[#F5F5F5] hover:border-[#ACB2BD] focus:outline-none focus:ring-2 focus:ring-[#FF6929] focus:border-transparent transition-colors duration-150 text-sm font-grotesk font-semibold ${
          longer ? "py-3" : "py-2"
        } rounded-lg ${fullWidth && "w-full"}`}
        placeholder="Search"
      />
    </div>
  );
};
